import template from './deliver_location.html';
import controller from './deliver_location.controller';
import './deliver_location.scss';

let deliverLocationComponent = {
  restrict: 'E',
  bindings: {
    model: '=ngModel',
    locations: '=',
    title: '=',
    isValidDirective: '=',
    isEdit: '='
  },
  template,
  controller
};

export default deliverLocationComponent;


// WEBPACK FOOTER //
// ./client/app/components/location/common/deliver_location/deliver_location.component.js